import _ from 'lodash';
import { reset } from 'redux-form';

export const ACCOUNT_FORM = 'account';
export const ADMIN_OVERRIDE_FORM = 'adminOverride';
export const DEALER_SETTINGS_MODAL_FORM = 'dealerSettingsModal';
export const LOGIN_FORM = 'login';
export const NEW_ACCOUNT_FORM = 'newAccount';
export const E_SIGN_MODAL_FORM = 'eSignModal';
export const PAYMENT_FORM = 'payment';
export const NEW_QUOTE_META_FORM = 'newQuote';
export const VSC_QUOTE_FORM = 'vscQuote';
export const GAP_QUOTE_FORM = 'gapQuote';
export const VEHICLE_BASIC_INFORMATION_FORM = 'vehicleBasicInformation';
export const VSC_RATE_FORM = 'vscRate';
export const GAP_RATE_FORM = 'gapRate';
export const CUSTOMER_INFORMATION_RATE_FORM = 'customerInformationRate';
export const LENDER_INFORMATION_RATE_FORM = 'lenderInformationRate';
export const QUOTE_SUMMARY_FORM = 'quoteSummary';
export const REGISTER_FORM = 'register';
export const SAVE_ACCOUNT_FORM = 'saveAccount';
export const NEW_USER_FORM = 'newUser';
export const ISSUED_CONTRACT_E_SIGN_DEMO = 'issuedContractESignDemo';
export const TEMPLATE_META_DATA_FORM = 'templateMetaData';
export const UPDATE_MESSAGING_MODAL_FORM = 'updateMessagingModal';

const ALL_FORMS = [
  ACCOUNT_FORM,
  ADMIN_OVERRIDE_FORM,
  LOGIN_FORM,
  NEW_ACCOUNT_FORM,
  DEALER_SETTINGS_MODAL_FORM,
  E_SIGN_MODAL_FORM,
  PAYMENT_FORM,
  NEW_QUOTE_META_FORM,
  VSC_QUOTE_FORM,
  GAP_QUOTE_FORM,
  VEHICLE_BASIC_INFORMATION_FORM,
  VSC_RATE_FORM,
  GAP_RATE_FORM,
  SAVE_ACCOUNT_FORM,
  CUSTOMER_INFORMATION_RATE_FORM,
  LENDER_INFORMATION_RATE_FORM,
  QUOTE_SUMMARY_FORM,
  ISSUED_CONTRACT_E_SIGN_DEMO,
  REGISTER_FORM,
  SAVE_ACCOUNT_FORM,
  NEW_USER_FORM,
  ISSUED_CONTRACT_E_SIGN_DEMO,
  // TEMPLATE_META_DATA_FORM
];

export function clearForms() {
  return (dispatch) => _.each(ALL_FORMS, (form) => dispatch(reset(form)));
}

export function clearForm(form) {
  return (dispatch) => dispatch(reset(form));
}



// WEBPACK FOOTER //
// ./src/redux/modules/form.js